import { gql } from '@apollo/client/core';

export const SNACKBAR = gql`
  mutation SNACKBAR($message: String, $type: String, $isOpen: Boolean, $duration: Int) {
    snackBar(message: $message, type: $type, isOpen: $isOpen, duration: $duration) @client
  }
`;
